<!-- Invoice PDF Preview Modal -->
<div class="modal fade" id="kt_modal_view_invoice" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header border-0 pb-0">
        <div class="d-flex align-items-center">
          <h2 class="modal-title fw-bold">Invoice PDF Preview</h2>
          <span class="badge badge-light-primary ms-3">{{ invoices.length }} Invoice(s)</span>
        </div>

        <div class="d-flex align-items-center gap-3">
          <!-- View Mode Selector - HIDDEN but functionality kept -->
          <!-- <div class="d-flex align-items-center">
            <label class="form-label fs-7 fw-semibold mb-0 me-2">View:</label>
            <select class="form-select form-select-sm w-150px"
                    [(ngModel)]="selectedViewMode"
                    (change)="onViewModeChange()">
              <option *ngFor="let mode of viewModes" [value]="mode.value">
                {{ mode.label }}
              </option>
            </select>
          </div> -->

          <!-- Multi-select Format Selector -->
          <div class="d-flex align-items-center position-relative" #modalFormatDropdownContainer>
            <label class="form-label fs-7 fw-semibold mb-0 me-2">Format:</label>
            <button class="btn btn-sm btn-light-primary w-250px text-start d-flex justify-content-between align-items-center"
                    type="button"
                    (click)="toggleFormatDropdown()">
              <span *ngIf="selectedFormatsInModal.length === 0" class="text-muted">Choose formats...</span>
              <span *ngIf="selectedFormatsInModal.length > 0">{{ selectedFormatsInModal.length }} format(s) selected</span>
              <i class="ki-duotone ki-down fs-5"></i>
            </button>

            <div class="dropdown-menu show w-250px p-3"
                 *ngIf="showFormatDropdown"
                 style="max-height: 300px; overflow-y: auto; position: absolute; top: 100%; right: 0; z-index: 1050;"
                 (click)="$event.stopPropagation()">
              <div *ngFor="let format of pdfFormats" class="form-check mb-2">
                <input class="form-check-input"
                       type="checkbox"
                       [id]="'modal_format_' + format.value"
                       [checked]="isFormatSelected(format.value)"
                       (change)="onFormatToggle(format.value)">
                <label class="form-check-label cursor-pointer"
                       [for]="'modal_format_' + format.value">
                  {{ format.label }}
                </label>
              </div>
            </div>
          </div>

          <!-- Close Button -->
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0" style="position: relative;">

        <!-- Format Tabs -->
        <div class="border-bottom bg-light" style="position: sticky; top: 0; z-index: 10;" *ngIf="selectedFormatsInModal.length > 0">
          <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-bold px-5">
            <li class="nav-item" *ngFor="let formatValue of selectedFormatsInModal">
              <a class="nav-link text-active-primary pb-4 pt-4"
                 [class.active]="activeFormatTab === formatValue"
                 (click)="onFormatTabChange(formatValue)"
                 style="cursor: pointer;">
                {{ getFormatLabel(formatValue) }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Scroll Indicator -->
        <div class="scroll-indicator text-center py-2 bg-light border-bottom" style="position: sticky; top: 48px; z-index: 9;">
          <small class="text-muted">
            <i class="ki-duotone ki-scroll fs-5 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Scroll down to view complete invoice
          </small>
        </div>

        <div class="pdf-preview-container" style="height: calc(100% - 88px); overflow-y: auto;">

          <!-- No Format Selected Message -->
          <div *ngIf="selectedFormatsInModal.length === 0" class="p-5 text-center">
            <div class="alert alert-info">
              <h4>No Format Selected</h4>
              <p>Please select at least one PDF format from the dropdown above.</p>
            </div>
          </div>

          <!-- Dynamic PDF Format Component based on active tab -->
          <ng-container *ngIf="selectedFormatsInModal.length > 0" [ngSwitch]="activeFormatTab">

            <!-- Imperial Solutions Format -->
            <app-plain-invoice
              *ngSwitchCase="'plain_invoice'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-plain-invoice>

            <!-- Caricom Invoice Format -->
            <app-caricom-invoice
              *ngSwitchCase="'caricom_invoice'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-caricom-invoice>

            <!-- Commercial Invoice Format -->
            <app-commercial-invoice
              *ngSwitchCase="'commercial_invoice'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-commercial-invoice>

            <!-- Shipping Information Format -->
            <app-shipping-information
              *ngSwitchCase="'shipping_information'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-shipping-information>

            <!-- Export Certificate Format -->
            <ng-container *ngSwitchCase="'export_certificate'">
              <div class="export-certificates-container">
                <!-- Show tabs for multiple invoices -->
                <div class="invoice-tabs-container mb-3" *ngIf="invoices.length > 1">
                  <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-bold">
                    <li class="nav-item" *ngFor="let inv of invoices; let i = index">
                      <a class="nav-link text-active-primary pb-3"
                         [class.active]="activeInvoiceIndex === i"
                         (click)="onInvoiceTabChange(i)"
                         style="cursor: pointer;">
                        Invoice {{ inv.invoice_number }}
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Display certificate for each invoice -->
                <div *ngFor="let inv of invoices; let i = index"
                     [hidden]="invoices.length > 1 && activeInvoiceIndex !== i">
                  <app-invoice-export-certificate
                    [invoice]="inv"
                    [showInvoiceHeader]="invoices.length === 1">
                  </app-invoice-export-certificate>
                </div>
              </div>
            </ng-container>

            <!-- House Bill of Lading Format -->
            <app-house-bill-landing
              *ngSwitchCase="'house_bill_landing'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-house-bill-landing>

            <!-- Standard Invoice Format (Dummy Invoice) -->
            <app-dummy-invoice
              *ngSwitchCase="'standard_invoice'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode"
              (editableDataChange)="onEditableDataChange($event)">
            </app-dummy-invoice>

            <!-- CTN Invoice Format -->
            <app-ctn-invoice
              *ngSwitchCase="'ctn_invoice'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-ctn-invoice>

            <!-- CTN Invoice Excel Format -->
            <app-ctn-invoice-excel
              *ngSwitchCase="'ctn_invoice_excel'"
              [invoices]="getProcessedInvoices()"
              [viewMode]="selectedViewMode">
            </app-ctn-invoice-excel>

            <!-- Default case -->
            <div *ngSwitchDefault class="p-5 text-center">
              <div class="alert alert-warning">
                <h4>Unknown Format</h4>
                <p>Please select a valid PDF format.</p>
              </div>
            </div>

          </ng-container>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-0">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="text-muted fs-7" *ngIf="activeFormatTab">
              Preview: {{ getFormatLabel(activeFormatTab) }}
            </span>
            <span class="text-muted fs-7" *ngIf="!activeFormatTab">
              No format selected
            </span>
          </div>

          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              Cancel
            </button>

            <button type="button"
                    class="btn btn-light-primary me-2"
                    [disabled]="isGenerating || invoices.length === 0 || !activeFormatTab"
                    (click)="generateActivePDF()">
              <span *ngIf="isGenerating" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isGenerating" class="ki-duotone ki-printer fs-4 me-1">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              <span *ngIf="isGenerating">Generating {{ currentGeneratingIndex }}/{{ totalToGenerate }}...</span>
              <span *ngIf="!isGenerating">Generate Active Tab</span>
            </button>

            <button type="button"
                    class="btn btn-primary"
                    [disabled]="isGenerating || invoices.length === 0 || selectedFormatsInModal.length === 0"
                    (click)="generatePDF()">
              <span *ngIf="isGenerating" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isGenerating" class="ki-duotone ki-printer fs-4 me-1">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              <span *ngIf="isGenerating">Generating {{ currentGeneratingIndex }}/{{ totalToGenerate }}...</span>
              <span *ngIf="!isGenerating">Generate All Formats</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
